import { ApiError, createApi } from '@dugzi/ui';

export { ApiError };

export const APP = 'drive';

// The shared client (F-26 M5). Drive has never sent X-Dugzi-Tab.
const client = createApi({ app: APP, product: 'Dugzi Drive', tabHeader: false });

/** Adds this tab's account (D-028) to a URL the browser loads by itself (downloads, exports). */
export const { withAccount } = client;

/** `anonymous`: a public link's call, without cookies or this tab's account; a 401 is then an ordinary error. */
export interface ApiOpts { method?: string; body?: unknown; headers?: Record<string, string>; anonymous?: boolean; signal?: AbortSignal }

// Changes still on their way to the server (trash, restore, move, rename…). A list that loads while one
// is in flight waits for it, so pressing Delete and going straight to Trash shows the file there.
const writes = new Set<Promise<unknown>>();
/** Resolves once every change sent so far has been answered (whether it worked or not). */
export function writesSettled(): Promise<unknown> {
  return writes.size ? Promise.allSettled([...writes]) : Promise.resolve();
}

/** JSON API client. A 401 sends the person to sign in and brings them back to where they were. */
export function api<T = any>(path: string, opts: ApiOpts = {}): Promise<T> {
  const method = opts.method ?? (opts.body !== undefined ? 'POST' : 'GET');
  const p = client.api<T>(path, opts);
  if (method !== 'GET') {
    writes.add(p);
    const done = () => { writes.delete(p); };
    p.then(done, done);
  }
  return p;
}
